import React from 'react';
import FormField from 'components/FormField/Index';
import { InputType } from 'core/enum/inputType';
import Button from 'components/Button/Index';
import './index.scss';

interface RecruiterActivationProfileFormProps {
  values: any;
  errors: any;
  touched: any;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  isValid: boolean;
  isSubmitting: boolean;
  t: any;
}

const RecruiterActivationProfileForm: React.FC<
  RecruiterActivationProfileFormProps
> = ({ values, errors, touched, setFieldValue, isValid, isSubmitting, t }) => {
  return (
    <div className="profileForm">
      <div className="profileForm__eform">
        <div className="mail">
          <div className="profileForm__email">
            <span className="section-label">{t('Name and Surname')}</span>
          </div>
          <FormField
            inputClassName="mail__input"
            fieldName="first_name"
            type={InputType.text}
            placeholder={t('First Name')}
          />
          <FormField
            inputClassName="mail__input"
            fieldName="last_name"
            type={InputType.text}
            placeholder={t('Last Name')}
          />
        </div>
      </div>

      {/* Job Title Section */}

      <div className="profileForm__eform">
        <div className="mail">
          <div className="profileForm__email">
            <span className="section-label">{t('Job Title')}</span>
          </div>
          <FormField
            inputClassName="mail__input"
            fieldName="job_title"
            type={InputType.text}
            placeholder={t('Your job title')}
          />
        </div>
      </div>

      {/* Password Section */}
      <div className="profileForm__pass">
        <div className="profileForm__email">
          <span className="section-label">{t('Please change your password')}</span>
        </div>
        <div className="passForm">
          <span className="label">{t('Old password')}</span>
          <FormField
            inputClassName="passForm__input"
            fieldName="oldPassword"
            type={InputType.password}
            placeholder={t('old password')}
          />

          <div className="repeats">
            <div className="repeats__field">
              <span className="label">{t('New password')}</span>
              <FormField
                inputClassName="passForm__input"
                fieldName="newPassword"
                type={InputType.password}
                placeholder={t('new password')}
              />
            </div>
            <div className="repeats__field">
              <span className="label">{t('Repeat password')}</span>
              <FormField
                inputClassName="passForm__input"
                fieldName="repeatPassword"
                type={InputType.password}
                placeholder={t('repeat password')}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecruiterActivationProfileForm;
